import Login from './pages/Login';
import { LoginProps } from '../Login/LoginForm';
import PrivateApp from 'Pages/App/PrivateApp';
import { Redirect } from 'react-router-dom';
import { getAppRoutes } from 'Pages/App/App.constants';
import { useState } from 'react';
import TermsAndCondition from '../TermsAndConditions/TermsAndCondition';
import { AuthUser } from 'Services/Api/Auth/Types';
import ChangePasswordForm from '../Login/Steps/ChangePasswordForm';
import NewAuthLayout from './layout/Layout';

type CognitoUserState = AuthUser | null;

export default function NewLogin({ firstTimeSignIn }: LoginProps) {
	const checktenanturl = window.location.href;
	const isAdmin =
		checktenanturl.includes('.io/login') ||
		checktenanturl.includes('.com/login');
	const [cognitoUser, setCognitoUser] = useState<CognitoUserState>(null);
	const [
		shouldMoveToTermsAndConditions,
		setShouldMoveToTermsAndConditions
	] = useState(false);

	const LoginComponent = () => {
		if (cognitoUser) {
			if (shouldMoveToTermsAndConditions) {
				return (
					<TermsAndCondition
						setShouldMoveToTermsAndConditions={
							setShouldMoveToTermsAndConditions
						}
						setCognitoUser={setCognitoUser}
					/>
				);
			}

			return (
				<NewAuthLayout variant="centered">
					<ChangePasswordForm
						cognitoUser={cognitoUser}
						setShouldMoveToTermsAndConditions={
							setShouldMoveToTermsAndConditions
						}
					/>
				</NewAuthLayout>
			);
		}

		return (
			<Login
				isAdminLogin={isAdmin}
				firstTimeSignIn={firstTimeSignIn}
				setShouldMoveToTermsAndConditions={
					setShouldMoveToTermsAndConditions
				}
				setCognitoUser={setCognitoUser}
			/>
		);
	};

	return (
		<PrivateApp>
			{(isAuthenticated) =>
				isAuthenticated ? (
					<Redirect to={getAppRoutes().HOME} />
				) : (
					LoginComponent()
				)
			}
		</PrivateApp>
	);
}
